(() => {
  if (window.felloxProductDetailsPlacement) {
    window.felloxProductDetailsPlacement();
    return;
  }
  const desktop = window.matchMedia('(min-width: 769px)');
  let details;
  let placeholder;
  function placeDetails() {
    const main = document.querySelector('.cc-main-product');
    const media = main && main.querySelector('#product-media');
    if (!details || !details.isConnected) {
      details = document.querySelector('.cc-product-details');
      placeholder = null;
    }
    if (!main || !media || !details) return;
    if (!placeholder) {
      placeholder = document.createComment('fellox-product-details-position');
      details.before(placeholder);
    }
    if (desktop.matches) {
      if (details.parentElement !== media) media.append(details);
      details.classList.add('fellox-details-under-media');
    } else {
      details.classList.remove('fellox-details-under-media');
      if (placeholder.parentNode) placeholder.after(details);
    }
  }
  window.felloxProductDetailsPlacement = placeDetails;
  desktop.addEventListener('change', placeDetails);
  document.addEventListener('shopify:section:load', placeDetails);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeDetails, { once: true });
  } else {
    placeDetails();
  }
})();